export const environment = {
  production: '%ENV_PRODUCTION%',
  hmr: '%ENV_HMR%',
  apiUrl: '%ENV_APIURL%',
  crypto_key: '%ENV_CRYPTO_KEY%',
  JASPER_IFRAME: "%JASPER_IFRAME%",
  s3_url: '%ENV_S3_URL%'
};
